import React from "react";
import { Collapse, Pre, Tag } from "@blueprintjs/core";
import { ProjectRunStatus } from "../types";
import "./ProjectInfo.scss";

type Props = {
    projectStatus: ProjectRunStatus;
    message: string;
};

export default function ProjectInfo({ projectStatus, message }: Props) {
    return (
        <div>
            <Tag large>Project</Tag>
            <Collapse isOpen={true}>
                <Pre>
                    {/* todo: move the style to scss file  */}
                    <p
                        style={{
                            textAlign: "left",
                            fontWeight: "lighter",
                            fontSize: "17px",
                            wordBreak: "break-all"
                        }}
                    >
                        {message}
                    </p>
                </Pre>
            </Collapse>
        </div>
    );
}
